import { useAIGenerator } from './hooks/useAIGenerator';
import { AIGeneratorForm } from './AIGeneratorForm';
import { t } from 'i18next';


const AITextGenerator = ({ disabled, title, setTitleGenerated, className, onStartGeneration }) => {
    const toneOptions = [
        { label: t("AI.Tone1"), value: "Ton professionnel et corporate" },
        { label: t("AI.Tone2"), value: "Ton énergique et enthousiaste avec des points d'exclamation" },
        { label: t("AI.Tone3"), value: "Ton chaleureux et naturel comme entre amis" },
        // { label: "Fun", value: "Résume ce titre de manière drôle et décontractée. N'hésite pas à être créatif!" }
    ];
    const { options, updateOption, generateContent } = useAIGenerator();

    const handleOptionChange = (key, value) => {
        updateOption(key, value);
    };

    const handleGenerate = async () => {
        onStartGeneration();

        const generatedTitle = await generateContent(
            'Titre',
            title,
            "Tu es un expert en réécriture de titres. Génère un nouveau titre en maximum 10 mots selon le ton demandé. Réponds UNIQUEMENT avec le titre, sans explication.",
            20
        );

        const cleanTitle = generatedTitle.replace(/^"(.*)"$/, '$1').replace(/^'(.*)'$/, '$1');


        setTitleGenerated(cleanTitle);
    };

    return (
        <AIGeneratorForm
            className={className}
            title={t("AI.Title")}
            onGenerate={handleGenerate}
            options={options}
            onOptionChange={handleOptionChange}
            toneOptions={toneOptions}
            disabled={disabled}
        />
    );
};

export default AITextGenerator;